import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { REQUIRED_VALIDATION } from "../../../../helpers/utils/formUtils";

const validationSchema = yup.object().shape({
    title: yup.string().required(REQUIRED_VALIDATION("Title")),
  });
  
  export const formOptions: any = {
    resolver: yupResolver(validationSchema),
    mode: "onTouched",
    reValidateMode: "onChange",
  };

  export const formatTitle = (slug: string) => {
    if (slug === "tour-video") {
      return "User Dashboard";
    } if (slug === "self-paced-scrum-master-onboarding-video") {
      return "Self Paced Scrum Master";
    } if (slug === "self-paced-product-manager-onboarding-video") {
      return "Self Paced Product Manager";
    } 
  return `${slug?.split("-")?.join(" ")}`
  };
  